(function () {
  function formatMoney(cents, format = '$ {{amount}}') {
    const value = typeof cents === 'number' ? cents : parseInt(cents, 10);
    let amount = value / 100;
    amount = amount.toFixed(2);
    return format.replace(/{{\s*amount.*?}}/, amount);
  }

  function getVariantData(root) {
    const host =
      root.querySelector('variant-radios') ||
      root.querySelector('variant-selects') ||
      root;

    const jsonEl = host.querySelector('[type="application/json"]');
    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

function updateButtonPrice(root, variantId) {
  const variants = getVariantData(root);
  if (!variants) return;

  const v = variants.find((x) => String(x.id) === String(variantId));
  if (!v) return;

  const btnPrice = root.querySelector('.product-pricing .product-price');
  const btnCompare = root.querySelector('.product-pricing .product-price-compare');
  const pricingWrap = root.querySelector('.product-pricing');

  if (btnPrice) btnPrice.textContent = formatMoney(v.price);

  const hasDiscount =
    v.compare_at_price &&
    Number(v.compare_at_price) > 0 &&
    Number(v.compare_at_price) > Number(v.price);

  if (btnCompare) {
    if (hasDiscount) {
      btnCompare.textContent = formatMoney(v.compare_at_price);
      btnCompare.removeAttribute('hidden');
      btnCompare.style.display = '';
    } else {
      btnCompare.textContent = '';
      btnCompare.setAttribute('hidden', 'hidden');
      btnCompare.style.display = 'none';
    }
  }

  // Si tu CSS necesita una clase para tachado/estilos, actívala aquí
  if (pricingWrap) pricingWrap.classList.toggle('is-on-sale', !!hasDiscount);
}


  function getCurrentVariantId(root) {
    return root.querySelector('input[name="id"]')?.value || null;
  }

  function bind(root) {
    if (!root || root.__qvPriceBound) return;
    root.__qvPriceBound = true;

    const refresh = () => {
      const id = getCurrentVariantId(root);
      if (id) updateButtonPrice(root, id);
    };

    // Inicial
    refresh();

    // Si alguien cambia el input por JS y dispara change, lo capturamos
    root.addEventListener('change', (e) => {
      const t = e.target;
      if (t && t.matches && t.matches('input[name="id"]')) refresh();
    });

    // Soporta el evento custom que estamos disparando desde quick-add.js
    root.addEventListener('variant:change', refresh);

    // Fallback: algunos themes cambian variante vía click en radios sin change inmediato
    root.addEventListener('click', () => setTimeout(refresh, 0));
  }

  window.initQuickViewButtonPrice = bind;
})();
